exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".voucher .el-input--suffix{height:36px}.voucher .el-input--suffix .el-input__inner{float:left}", ""]);

// exports
